
import { Container, Button } from 'react-bootstrap';

const CourseSection = () => {
  return (
    <>
     
    <Container fluid className="course-section">
      {/* Become an Instructor Banner */}
      <div className="instructor-banner p-4 my-2 text-center" style={{ backgroundColor: '#109091', borderRadius: '8px' }}>
        <h4 className='text-white fw-bold text-center'>Become A Instructor</h4>
        <p className='fw-bold text-white' >We are looking for an highly qualified tutor...? Join  as a <span style={{ textDecoration: 'underline' }}>instructor by submitting the form below </span></p>
        <Button variant="dark" className="mt-2" href= "/instructor" >Submit Application</Button>
      </div>
     
    </Container>
    </>
  );
};

export default CourseSection;

